import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Find your tenant ID in the access URLs for your Commerce Optimizer project in Cloud Manager.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in to your `}<a parentName="p" {...{
            "href": "https://experience.adobe.com/"
          }}>{`Adobe Experience Cloud`}</a>{` account.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under `}<strong parentName="p">{`Quick access`}</strong>{`, click `}<strong parentName="p">{`Commerce`}</strong>{` to open the Commerce Cloud Manager.`}</p>
        <p parentName="li">{`The Commerce Cloud Manager displays a list of instances that are available in your Adobe IMS organization.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To view the access URLs including the base URL for the REST and GraphQL APIs, click the information icon next to the instance name.`}</p>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.4375%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/5530d/aco-instance-tenant-id.webp 320w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/0c8fb/aco-instance-tenant-id.webp 640w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/94b1e/aco-instance-tenant-id.webp 1280w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/e0858/aco-instance-tenant-id.webp 1480w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/dd4a7/aco-instance-tenant-id.png 320w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/0f09e/aco-instance-tenant-id.png 640w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/bbbf7/aco-instance-tenant-id.png 1280w", "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/163ec/aco-instance-tenant-id.png 1480w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/commerce/services/static/04b7605a8ce07e9ece904c83de61c39f/bbbf7/aco-instance-tenant-id.png",
                "alt": "Access URLs for Commerce Optimizer UI, REST, and GraphQL APIs",
                "title": "Access URLs for Commerce Optimizer UI, REST, and GraphQL APIs",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`{zoomable="yes"}`}</p>
        <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
        <p parentName="li">{`If you don't have access to the Commerce Cloud Manager, contact your system administrator.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      